/**
 * Legal: Kullanım Şartları & İptal Politikası — sürümlü.
 *
 * TERMS_VERSION her güncellemede bump edilir; backend bu sürüm bilgisini
 * customer dökümanına timestamp + IP ile birlikte yazar (Phase 8.1).
 *
 * Yapı: bölümlere ayrılmış maddeler — modal içinde scrollable olarak render edilir.
 * Yeni bir madde eklerken `id` benzersiz kalmalı (audit trail için).
 */
export const TERMS_VERSION = "v1.0-2026-02";
export const TERMS_EFFECTIVE_DATE = "Şubat 2026";

export const TERMS_SECTIONS = [
  {
    id: "service",
    title: "1. Hizmet Tanımı",
    body:
      "Platformumuz, abonelik temelli dijital yayın (IPTV) erişimi sağlar. Aboneliğinizin ödemesi onaylandığı anda hesabınız aktive edilir ve seçtiğiniz plan süresi başlar.",
  },
  {
    id: "billing",
    title: "2. Abonelik ve Ücretlendirme",
    body:
      "Aboneliğiniz, siz iptal etmediğiniz sürece seçtiğiniz dönem (3 / 6 / 12 ay) sonunda mevcut tarifeye göre otomatik olarak yenilenir. Yenileme öncesinde kayıtlı e-posta adresinize bildirim gönderilir. İptal işlemini abone panelinizden istediğiniz zaman gerçekleştirebilirsiniz.",
  },
  {
    id: "refund",
    title: "3. İade Politikası",
    body:
      "Hizmetimiz dijital içerik kapsamında olup ödeme onayının ardından erişim anında aktive edilmektedir. Bu nedenle yayın açıldıktan (hesabınız aktive edildikten) sonra ücret iadesi yapılamaz. Ödeme öncesi hesabınız henüz aktive edilmemişse iade talebinizi destek ekibine iletebilirsiniz.",
  },
  {
    id: "tech-interruptions",
    title: "4. Teknik Kesintiler",
    body:
      "Yayın hizmetlerimizde sunucu güncellemeleri, planlı bakım, kanal sağlayıcı kaynaklı sinyal kayıpları veya beklenmeyen teknik sorunlar nedeniyle zaman zaman geçici kesintiler yaşanabilir. Bu tür kesintiler, mümkün olan en kısa sürede giderilmek üzere sürekli izlenir; ancak hizmet sürekliliği için kesintisiz uptime garantisi verilmez.",
  },
  {
    id: "isp-liability",
    title: "5. İSS ve İçerik Sorumluluk Reddi",
    body:
      "Yayın akışında oluşabilecek donma, gecikme veya çözünürlük düşüşleri büyük ölçüde kullanıcının İnternet Servis Sağlayıcısı (İSS), yerel ağ koşulları ve cihaz performansı ile ilişkilidir. Platformumuz, İSS kaynaklı performans sorunlarından sorumlu tutulamaz. Ayrıca kanal sağlayıcılarının yayın listesinde, programında veya içerik haklarında yapacakları değişiklikler nedeniyle bazı kanalların kaldırılması veya yeniden düzenlenmesi durumunda platformumuz ilgili değişikliklerden sorumlu değildir.",
  },
  {
    id: "compliance",
    title: "6. Kullanım Kuralları",
    body:
      "Hesap bilgileriniz size özeldir; üçüncü kişilerle paylaşılması, yetkisiz cihazlardan çoklu erişim ve yayın akışının yeniden dağıtılması yasaktır. Bu maddelere aykırı kullanım tespit edildiğinde aboneliğiniz iade yapılmaksızın askıya alınabilir.",
  },
  {
    id: "contact",
    title: "7. İletişim",
    body:
      "Sözleşme veya hizmet ile ilgili her türlü soru ve talep için 7/24 destek kanallarımızı kullanabilirsiniz. Bu sözleşme, Şubat 2026 itibarıyla yürürlüktedir ve gerekli görüldüğünde güncellenebilir; güncellenmiş sürüm yeniden onayınıza sunulur.",
  },
];
